export default __webpack_public_path__ + "b056a4efca9c769db2872407aff5edea.png";